//Close Menu
  let menuCloseContainer = document.getElementById("Details-menu-drawer-container");
  let menuCloseBtn = document.getElementById("menuCloseBtn");

    menuCloseBtn.addEventListener('click', function(e) {
    menuCloseContainer.classList.remove("menu-opening");
    menuSummaryFocus.setAttribute('aria-expanded', false);
  })
//Customer review slider
var owl = $('.owl-customer');
owl.owlCarousel({
  loop:true,
  nav:false, 
  margin:55,
  autoplay:true,
  dots: true,
  items:3,
  onInitialized: equalizeHeights,
  onResized: equalizeHeights,
  responsive:{
    0:{
      items:1,
    },
    500:{
      items:1,
    },
    767:{
      items:2,
    },            
    960:{
      items:2,
    },
    1200:{
      items:3,
    }
  }
});
//Slider Equal Height
function equalizeHeights(event) {
  var maxHeight = 0;
  
  $(".owl-customer .owl-item").each(function(){
    var itemHeight = $(this).height();
    if (itemHeight > maxHeight) {
      maxHeight = itemHeight;
    }
  });
  
  $(".owl-customer .owl-item").css("height", maxHeight + "px");
}
//Supplements heading Equal Height
function equalizeHeights(e) {
  var maxHeadingHeight = 0;
  
  $(".supportlisting .item > h3").each(function(){
    var itemHeadingHeight = $(this).height();
    console.log(itemHeadingHeight,'itemHeadingHeight');
    if (itemHeadingHeight > maxHeadingHeight) {
      maxHeadingHeight = itemHeadingHeight;
    }
  });
  
  $(".supportlisting .item > h3").css("min-height", maxHeadingHeight + "px");
}
//Smooth Scroll
$('a[href^="#"]').on('click', function(event) {
  if (this.hash !== "") {
    event.preventDefault();
    var hash = this.hash;
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 1000, function() {
      window.location.hash = hash;
    });
  }
});
//Product Slider
var owlProduct = $('.owl-product');
owlProduct.owlCarousel({
  loop:true,
  nav:true, 
  margin:55,
  autoplay:true,
  dots: true,
  items:1,
});

//Video Slider
let owlVideo = $('.owl-video');
owlVideo.owlCarousel({
  loop: true,
  nav: false,
  margin: 55,
  autoplay: false,
  autoplayTimeout:7000,
  dots: true,
  items: 3,
  autoplayHoverPause: true,
  responsive:{
    0:{
      items:1,
    },
    500:{
      items:1,
    },
    767:{
      items:2,
    },            
    960:{
      items:2,
    },
    1200:{
      items:3,
    }
  },
  onTranslate: function () {
    $('.owl-item video').each(function () {
      this.pause();
    })
  }
});

$(document).ready(function () {
  var allVideos = $('.owl-item video');
  allVideos.on('play', function () {
    allVideos.not(this).each(function () {
      this.pause();
    });
  });
});

//open third party link in a new tab
$(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (
      links[i].hostname !== window.location.hostname &&
      !links[i].href.startsWith('mailto:') &&
      !links[i].href.startsWith('tel:')
    ) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }



  
  /**
    Add free product with the main product
  **/
  $('body').on('click', '.product-form__submit', function(event) {
    event.preventDefault();
    let _items = [];
    let _mainProdId = $('.product-variant-id').val();
    let _mainProdQty = $('.quantity__input').val();
    let _isMainProdAdded = false;
    _items.push({id: _mainProdId, quantity: _mainProdQty});
    if($('.free-product-variant-id').length) {
      if($('.free-product-variant-id').val() != '' && $('.free-product-variant-id').val() != null) {
        _items.push({id: $('.free-product-variant-id').val(), quantity: _mainProdQty});
      }
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items : _items
      },
      dataType: 'json',
      success: function(data) {
        window.location.href= '/cart'
      }
    });
  });

  /**
   Increase & Decrease quantity
  **/
  $('body').on('change blur', '.quantity__input', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let _this = $(this);
    let _actName = '';
    let _freeProdId = $(this).data('free-prod-id');
    let _mainProdId = $(this).data('main-prod-id');
    let _oldMainProdQty = parseInt($(this).data('old-quantity'));
    let _mainProdQty = parseInt(0);
    let _freeProdQty = parseInt(0);
    let _changeQty = parseInt(0);
    if($('.' + _mainProdId + '_qty_input').length) {
      _mainProdQty = parseInt($('.' + _mainProdId + '_qty_input').val());
    }
    if($('.' + _freeProdId + '_qty_input').length) {
      _freeProdQty = parseInt($('.' + _freeProdId + '_qty_input').val());
    }
    if(_mainProdQty > _oldMainProdQty) {
      _actName = 'plus';
      _changeQty = _mainProdQty - _oldMainProdQty;
    }
    if(_mainProdQty < _oldMainProdQty) {
      _actName = 'minus';
      _changeQty =  _oldMainProdQty - _mainProdQty;
    }
    if(_actName == 'plus') {
      if(parseInt(_freeProdQty) > 0) {
        _freeProdQty = parseInt(_freeProdQty) + _changeQty;
      }
    }
    if(_actName == 'minus') {
      if(parseInt(_freeProdQty) > 0) {
        _freeProdQty = parseInt(_freeProdQty) - _changeQty;
      }
    }
    if(_actName != '') {
      $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: {
              quantity: _mainProdQty,
              id: _mainProdId
          },
          beforeSend: function() {
            _this.parents('tr.cart-item').find('td.cart-item__totals').find('.loading-overlay').removeClass('hidden');
          },
          success: function (data) {
            if (_freeProdId != '') {
              $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  dataType: 'json',
                  data: {
                      quantity: _freeProdQty,
                      id: _freeProdId
                  },
                  success: function (data){
                    setTimeout(() => {
                      window.location.href = '/cart';  
                    }, 1000);
                  },
                  error: function (xhr, status, error) {
                    window.location.href = '/cart';
                  }
              });
            } else {
              setTimeout(() => {
                window.location.href = '/cart';  
              }, 1000);
            }
          },
          error: function (xhr, status, error) {
            window.location.href = '/cart';
          }
      });
    }
    return false;
  });

  /**
    Delete cart item
  **/
  $('body').on('click', '.button--tertiary', function (e) {
    e.preventDefault();
    e.stopPropagation();
    let _delUrl = $(this).attr('href');
    let _freeProdId = $(this).data('free-prod-id');
    let _mainProdId = $(this).data('main-prod-id');
    let _mainProdQty = 0;
    let _freeProdQty = 0;
    if($('.' + _mainProdId + '_qty_input').length) {
      _mainProdQty = parseInt($('.' + _mainProdId + '_qty_input').val());
    }
    if($('.' + _freeProdId + '_qty_input').length) {
      _freeProdQty = parseInt($('.' + _freeProdId + '_qty_input').val());
      _freeProdQty = _freeProdQty - _mainProdQty;
    }
    if(parseInt(_freeProdQty) <= 0) {
      _freeProdQty = 0;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            id: _mainProdId
        },
        success: function (data) {
          if (_freeProdId != '') {
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                    quantity: _freeProdQty,
                    id: _freeProdId
                },
                success: function (data){
                  setTimeout(() => {
                    window.location.href = '/cart';  
                  }, 1000);
                },
                error: function (xhr, status, error) {
                  window.location.href = 'https://petjoy.com/cart';
                }
            });
          } else {
            setTimeout(() => {
              window.location.href = '/cart';  
            }, 1000);
          }
        },
        error: function (xhr, status, error) {
          window.location.href = window.Shopify.routes.root + _delUrl;
        }
    });
    return false;
  });

  $('body').on('keyup keypress', '.quantity__input', function(e) {
    if (e.keyCode === 13 || e.keyCode === 46) {
        return false;
    }
  });

  $('body').on('click', '#saveInvestBtn', async function() {
    const regxPhone = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(document.getElementById('firstName').value == '') {
      document.getElementById('firstName').classList.add('error-field');
      document.getElementById('respMsg').innerHTML = "Please enter first name";
      document.getElementById('respMsg').classList.remove('success-text');
      document.getElementById('respMsg').classList.add('error-text');
    } else if(document.getElementById('lastName').value == '') {
      document.getElementById('lastName').classList.add('error-field');
      document.getElementById('respMsg').innerHTML = "Please enter last name";
      document.getElementById('respMsg').classList.remove('success-text');
      document.getElementById('respMsg').classList.add('error-text');
    } else if(document.getElementById('emailAddress').value == '') {
      document.getElementById('emailAddress').classList.add('error-field');
      document.getElementById('respMsg').innerHTML = "Please enter email address";
      document.getElementById('respMsg').classList.remove('success-text');
      document.getElementById('respMsg').classList.add('error-text');
    } else if(!emailRegex.test(document.getElementById('emailAddress').value)) {
      document.getElementById('emailAddress').classList.add('error-field');
      document.getElementById('respMsg').innerHTML = "Please enter valid email address";
      document.getElementById('respMsg').classList.remove('success-text');
      document.getElementById('respMsg').classList.add('error-text');
    } else if(document.getElementById('phoneNumber').value == '') {
      document.getElementById('phoneNumber').classList.add('error-field');
      document.getElementById('respMsg').innerHTML = "Please enter phone number";
      document.getElementById('respMsg').classList.remove('success-text');
      document.getElementById('respMsg').classList.add('error-text');
    } else if(!regxPhone.test(document.getElementById('phoneNumber').value)) {
      document.getElementById('phoneNumber').classList.add('error-field');
      document.getElementById('respMsg').innerHTML = "Please enter valid phone number";
      document.getElementById('respMsg').classList.remove('success-text');
      document.getElementById('respMsg').classList.add('error-text');
    } else {
      document.getElementById('saveInvestBtn').disabled = true;
      document.getElementById('respMsg').classList.remove('error-text');
      document.getElementById('respMsg').classList.remove('success-text');
      document.getElementById('respMsg').innerHTML = "Please wait...";
      let obj = {
        first_name: document.getElementById('firstName').value,
        last_name: document.getElementById('lastName').value,
        email: document.getElementById('emailAddress').value,
        phone: document.getElementById('phoneNumber').value,
        notes: document.getElementById('anyNote').value,
        actionkey: "SAVE"
      };
      await fetch("https://script.google.com/macros/s/AKfycbzpvclUQU8i6z7N0dK-wybP5UAGFHDbjz0ie2Gc5PkVrAj4-YxG0CH4jL98EXAPefWt/exec", {
          method: "POST",
          body: JSON.stringify(obj)
      }).then((response) => {
          return response.text();
      }).then((data) => {
          if(data == "SUCCESS") {
            document.getElementById('firstName').value = '';
            document.getElementById('lastName').value = '';
            document.getElementById('emailAddress').value = '';
            document.getElementById('phoneNumber').value = '';
            document.getElementById('anyNote').value = '';
            document.getElementById('saveInvestBtn').disabled = false;
            document.getElementById('respMsg').classList.add('success-text');
            document.getElementById('respMsg').classList.remove('error-text');
            document.getElementById('respMsg').innerHTML = "Submitted! We will get back to you soon.";
          }
      }).catch((error) => {
          console.log(error);
      });
    }
  });

});
